















































import Vue, { PropType } from 'vue';
import { Boleto, BoletoAluguel, BoletoCondominio, Sistema, isBoletoAluguel, isBoletoCondominio } from '../../../../store/boletos';
import { Endereco } from '../../../../store/boletos';
import ItemLista from './item-lista-print.vue'

export default Vue.extend({
    components: {
        ItemLista
    },
    props: {
        boletos: {
            type: Array as PropType<BoletoAluguel[] | BoletoCondominio[]>
        },
        sistema: {
            type: String as PropType<Sistema>
        }
    },
    computed: {
        agrupados() {
            let boletos: Boleto[] = this.boletos
            let sistema: Sistema = this.sistema

            type Resumo = {
                total: number,
                unidade: string
                endereco: Endereco
                boletos: Boleto[]
            }


            if (sistema === Sistema.ALUGUEL) {
                let rows = boletos.filter(isBoletoAluguel)



                let agrupado: Map<number, Resumo> = rows.reduce<Map<number, Resumo>>((acc, boleto) => {
                    let resumo = acc.get(boleto.imovel.codigo)
                    if (!resumo) {
                        resumo = {
                            total: 0,
                            unidade: `${boleto.imovel.subcodigo} - ${boleto.imovel.filial.abrev}`,
                            endereco: boleto.imovel.endereco,
                            boletos: []
                        }
                    }
                    resumo.boletos.push(boleto)
                    resumo.total += boleto.valorAtualizado

                    acc.set(boleto.imovel.codigo, resumo)

                    return acc
                }, new Map())


                return Array.from(agrupado.values())
            } else {
                let rows = boletos.filter(isBoletoCondominio)

                let agrupado: Map<number, Resumo> = rows.reduce<Map<number, Resumo>>((acc, boleto) => {
                    let resumo = acc.get(boleto.unidade.codigo)
                    if (!resumo) {
                        resumo = {
                            total: 0,
                            unidade: boleto.unidade.descricao,
                            endereco: boleto.unidade.condominio.endereco,
                            boletos: []
                        }
                    }
                    resumo.boletos.push(boleto)
                    resumo.total += boleto.valorAtualizado

                    acc.set(boleto.unidade.codigo, resumo)

                    return acc
                }, new Map())


                return Array.from(agrupado.values())
            }

        },
        total() {
            let boletos: Boleto[] = this.boletos
            return boletos.reduce((acc, boleto) => acc + boleto.valorAtualizado, 0.0)
        }
    },
    methods: {
        onUpdated(boleto: Boleto) {
            this.$emit('updated', boleto)
        }
    }
})



